import React from 'react'
import { InputSelect } from '../../../comp/InputSelect'
import { Traduccion } from '../../../comp/Traduccion'

export const InputSelectPuntosDeVenta = ({id, value = null, listOfValues, onChange, requerido, editable, validarSubmit, isLoading}) => {

    React.useEffect(() => {
        if (listOfValues?.length === 1 && requerido) {
            onChange(listOfValues[0], id)
        }
    }, [listOfValues, requerido, onChange, id])

    const getListaDeOpciones = () => {
        let aux = listOfValues.map(e => {return {label: String(e.numero).padStart(5, '0'), value: e.id}})
        if (requerido) {
            aux.length > 1 && aux.unshift({label: Traduccion('TXT_SELECCIONE'), value: ''})
        } else {
            aux.unshift({label: Traduccion('TXT_SELECCION_TODAS'), value: ''})
        }
        return aux
    }

    const getValorSeleccionado = () => value?.id ?? ''
    const onValueChange = (v) => onChange(
        v === '' ? null : listOfValues.find(e => e.id === v),
        id
    )

    return <InputSelect id={id}
                label={Traduccion('TXT_PUNTO_DE_VENTA')}
                value={getValorSeleccionado()}
                onChange={onValueChange}
                options={getListaDeOpciones()}
                isLoading={isLoading}
                editable={editable}
                requerido={requerido}
                validarSubmit={validarSubmit}/>
}